export enum ETranslationEvents {
  ViewTranslationText = 'ViewTranslationText',
  CloseTranslationText = 'CloseTranslationText',
  WebRepeatTranslation = 'WebRepeatTranslation',
  AppStoreDownloadButton = 'AppStoreDownloadButton',
  GooglePlayDownloadButton = 'GooglePlayDownloadButton',
  ClickLogoHT = 'ClickLogoHT',
  ClickTranslationLink = 'ClickTranslationLink'
}
